export default "__VITE_ASSET__d1d2e2bd__"